import { useInstallPrompt } from '../hooks/useInstallPrompt';

/** iOS dela-ikon (fyrkant med uppåtpil) för att peka ut rätt knapp. */
function ShareGlyph() {
  return (
    <svg
      className="install-share"
      viewBox="0 0 24 24"
      width="17"
      height="17"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      <path d="M12 14V4" />
      <path d="M8 7l4-4 4 4" />
      <path d="M6 12v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-7" />
    </svg>
  );
}

export function InstallPrompt() {
  const { open, platform, install, dismiss } = useInstallPrompt();
  if (!open || !platform) return null;

  return (
    <div className="install-modal-backdrop" onClick={dismiss}>
      <div
        className="install-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Spara Bilmat som app"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="install-modal-close" onClick={dismiss} aria-label="Stäng">
          ×
        </button>
        <img src="/apple-touch-icon.png" alt="" className="install-modal-icon" />
        <h2 className="install-modal-title">Spara Bilmat som app</h2>
        <p className="install-modal-sub">
          Snabb åtkomst direkt från hemskärmen — som en riktig app, utan webbläsarfält.
        </p>

        {platform === 'ios' ? (
          <>
            <ol className="install-steps">
              <li>
                <span className="install-step-n">1</span>
                <span>
                  Tryck på <ShareGlyph /> i verktygsraden längst ned
                </span>
              </li>
              <li>
                <span className="install-step-n">2</span>
                <span>
                  Välj <strong>”Lägg till på hemskärmen”</strong>
                </span>
              </li>
              <li>
                <span className="install-step-n">3</span>
                <span>
                  Tryck <strong>”Lägg till”</strong>
                </span>
              </li>
            </ol>
            <button type="button" className="install-modal-later" onClick={dismiss}>
              Inte nu
            </button>
            <svg
              className="install-arrow"
              viewBox="0 0 24 24"
              width="34"
              height="34"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
              focusable="false"
            >
              <path d="M12 4v15" />
              <path d="M5 13l7 7 7-7" />
            </svg>
          </>
        ) : (
          <>
            <button type="button" className="install-modal-btn" onClick={install}>
              Installera
            </button>
            <button type="button" className="install-modal-later" onClick={dismiss}>
              Inte nu
            </button>
          </>
        )}
      </div>
    </div>
  );
}
